import React from 'react';
import { connect } from 'react-redux';
import SubscribeToDaily from '../SubscribeToDaily/SubscribeToDaily';
import { AdBanner, AD_SLOT_TYPE__BOTTOM, AD_SLOT_TYPE__TOP } from '@emarketer/googleadmanager';
import { navigation_geo_select_geo, navigation_toggle_open } from '../../redux/reducers/navigationSlice';
import HomeTabs from './HomeTabs/HomeTabs';
import { AdTopWrapper } from '../AdWrappers/AdWrappers';

import {
  HomeContainerWrapper,
  ForecastsContainer,
  NewsletterSignupForm,
  ForecastsIntro,
  ForecastsTitle,
  ForecastsSubtitle,
  ForecastsFilters,
  ForecastsHeaderWrapper,
  TabWrapper,
  IndexWrapper,
  AdBottomWrapper,
} from './HomeContainer.styled';
import FiltersContainer from '../Filters/FiltersContainer';

interface IHomeState {
  selectedChannel: string;
  showAll: boolean;
}

function mapStateToProps(state, ownProps) {
  return {
    SelectedChannel: state.navigation.selectedChannel,
    SelectedGeography: state.navigation.selectedGeography,
    Channels: state.navigation.channels,
    CompareCountries: state.navigation.compareCountries,
    isLoggedIn: state.auth.authenticated,
  };
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    selectGeography: (geography) => {
      dispatch(navigation_geo_select_geo(geography));
    },
    openNavToggle: () => {
      dispatch(navigation_toggle_open());
    },
  };
};

class HomeContainer extends React.Component<
  {
    isMobile: boolean;
    Channels: any;
    SelectedChannel: any;
  },
  IHomeState
> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { isMobile } = this.props;

    return (
      <HomeContainerWrapper>
        <IndexWrapper>
          <ForecastsContainer>
            <AdTopWrapper>
              <AdBanner adSlotType={AD_SLOT_TYPE__TOP} />
            </AdTopWrapper>
            <ForecastsIntro>
              <ForecastsHeaderWrapper>
                <ForecastsTitle>Forecasts</ForecastsTitle>
                <ForecastsSubtitle>
                  Visualize how digital trends are evolving using vetted and unbiased data
                </ForecastsSubtitle>
                <ForecastsFilters>
                  <FiltersContainer />
                </ForecastsFilters>
              </ForecastsHeaderWrapper>
            </ForecastsIntro>
          </ForecastsContainer>
          <TabWrapper isMobile={isMobile}>
            <HomeTabs isMobile={isMobile} />
          </TabWrapper>
          <NewsletterSignupForm id="Forecasts-Home-Newsletter-Signup">
            <SubscribeToDaily
              bodyText="Sign up for EMARKETER Daily, our free newsletter."
              acceptTerms={false}
              inputPlaceholderText="Business Email"
              submitText="Sign up"
            />
          </NewsletterSignupForm>
        </IndexWrapper>
        <AdBottomWrapper>
          <AdBanner adSlotType={AD_SLOT_TYPE__BOTTOM} />
        </AdBottomWrapper>
      </HomeContainerWrapper>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
